import type { SearchParams } from '@/server/searchParams.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import { createQueryString } from '@/utils/queryUtils.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { removeParameters } from '@/app/common/urlParametersUtils.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { getIsPinkPeopleEnabled, removePinkPeopleParams } from './utils';
import getSearchParams from '../common/getSearchParams';
import type { Localization } from '../common/Localization';

type CreateSearchParamsPinkPeopleFromFilters = {
  searchParams: SearchParams;
  searchInfoData: SearchInfoData;
  appliedFilters: SearchParams;
  commonData: CommonData;
  localization: Localization;
};
export const createSearchParamsPinkPeopleFromFilters = ({
  searchParams,
  searchInfoData,
  appliedFilters,
  commonData,
  localization,
}: CreateSearchParamsPinkPeopleFromFilters): SearchParams | undefined => {
  const isPinkPeopleEnabled = getIsPinkPeopleEnabled({
    searchInfoData,
    commonData,
    localization,
  });
  if (!isPinkPeopleEnabled) return undefined;

  const currentSearchParams = getSearchParams();
  const pinkPeopleFilterChanged = currentSearchParams.pinkpeople !== appliedFilters.pinkpeople;
  if (!pinkPeopleFilterChanged) return undefined;

  const searchParamsWithoutSearchIds = removeParameters(searchParams, [
    URLParameters.SEARCH_ID,
    URLParameters.VC_SEARCH_ID,
  ]);

  if (appliedFilters.pinkpeople === '1') {
    return { ...searchParamsWithoutSearchIds, businessProfileId: localization?.configValuesApp?.pinkPeopleBP };
  }

  if (searchParamsWithoutSearchIds.businessProfileId === localization?.configValuesApp?.pinkPeopleBP) {
    const searchParamsWithoutPinkPeopleParams = removePinkPeopleParams(searchParamsWithoutSearchIds);
    window.history.replaceState(null, '', `?${createQueryString(searchParamsWithoutPinkPeopleParams)}`);
    return searchParamsWithoutPinkPeopleParams;
  }

  return undefined;
};
